import React from 'react';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import { Translate } from 'react-redux-i18n';
import FIELDS from '../../../../data/fields';
import { getUsers } from '../../../../app/store/actions/users';

let clientHelper = '';

class ApproveInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 1000,
      skip: '',
      clientId: props.clientId,
      search: '',
      type: '',
      status: '',
      orderBy: 'ASC',
      field: 'userId',
      emailSearch: '',
      isApproveSelected: false,
      approveId1: '',
      approveId2: '',
      approveEmail1: '',
      approveEmail2: '',
    };
  }

  componentDidMount = async () => {
    await this.searchUsers();
    const { userId } = this.props;
    const { rows } = this.props.users;
    this.usersWithPermission = rows
      .filter(user => (user.cartUsersPermission === true && userId !== user.userId))
      .map(user => user.user);
  }

  componentDidUpdate = (previousProps) => {
    const {
      setApproveId1, setApproveId2, setApproveEmail1, setApproveEmail2,
    } = this.props;

    if ((previousProps.permission !== this.props.permission)
        && (this.props.permission)) {
      this.state.emailSearch = '';
      this.state.isApproveSelected = false;
    }

    setApproveId1(this.state.approveId1);
    setApproveId2(this.state.approveId2);
    setApproveEmail1(this.state.approveEmail1);
    setApproveEmail2(this.state.approveEmail2);
  }

  searchUsers = async () => {
    const { searchItems } = this.props;
    const {
      limit, skip, search, clientId, type, status, orderBy, field,
    } = this.state;
    await searchItems(limit, skip, clientId, search, type, status, orderBy, field);
  }


  setSelectedContactGlobal = (item) => {
    clientHelper = item;
    return item.email;
  }

  setSearchOnChange = (search) => {
    this.setState({ emailSearch: search });
  }

  setSelectedSphereContact = (email) => {
    const { id } = clientHelper;
    if (this.props.type === 'firstApproved') {
      const approver = {
        id,
        email,
      };
      this.setState({
        emailSearch: email,
        approveEmail1: email,
        approveId1: id,
        isApproveSelected: true,
      }, () => {
        this.props.setApprover(approver, this.props.type);
        this.props.onCheckBox(this.props.permission, this.props.type);
      });
    } else {
      const approver = {
        id,
        email,
      };
      this.setState({
        emailSearch: email,
        approveEmail2: email,
        approveId2: id,
        isApproveSelected: true,
      }, () => {
        this.props.setApprover(approver, this.props.type);
        this.props.onCheckBox(this.props.permission, this.props.type);
      });
    }
  }

  resetEmail = () => {
    this.setState({ emailSearch: '', isApproveSelected: false });
  }

  renderInput = (permission, emailSearch) => {
    switch (permission) {
      case false:
        return (
          <input
            type="text"
            className="form-control"
            value=""
            maxLength={FIELDS.max}
            disabled
          />
        );
      case true:
        return (
          <Autocomplete
            getItemValue={item => this.setSelectedContactGlobal(item)}
            items={this.usersWithPermission || []}
            className="form-control custom-select autocomplete-custom z-index"
            renderItem={(item, isHighlighted) => (
              <div key={item.id} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.email}
              </div>
            )}
            maxLength={FIELDS.max}
            value={emailSearch}
            onChange={search => this.setSearchOnChange(search.target.value)}
            onSelect={search => this.setSelectedSphereContact(search)}
          />
        );
      default:
        return <div />;
    }
  }

  render() {
    const { permission } = this.props;
    const { emailSearch } = this.state;

    return (
      <div className="form-group autocomplete-client">
        {
          (this.state.isApproveSelected && permission) ? (
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="email" />
                <span
                  className="ml-2 change-input-link"
                  role="button"
                  tabIndex={0}
                  onKeyDown={this.resetEmail}
                  onClick={this.resetEmail}
                >
                  (
                  <Translate value="change" />
                  )
                </span>
              </p>
              <input
                type="text"
                className="form-control"
                value={emailSearch}
                disabled
              />
            </div>
          ) : (
            this.renderInput(permission, emailSearch)
          )
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, clientId, search, type, status, order, field) => dispatch(getUsers(limit, skip, clientId, search, type, status, order, field)),
  setApproveId1: approveId => dispatch({ type: 'GET_APPROVE_ID1', payload: approveId }),
  setApproveId2: approveId => dispatch({ type: 'GET_APPROVE_ID2', payload: approveId }),
  setApproveEmail1: approveEmail => dispatch({ type: 'GET_APPROVE_EMAIL1', payload: approveEmail }),
  setApproveEmail2: approveEmail => dispatch({ type: 'GET_APPROVE_EMAIL2', payload: approveEmail }),
});

const mapStateToProps = state => ({
  users: state.users.users,
});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveInput);
